// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3zBXx","legacyBtn":"MutateMid_legacyBtn__2ypUr"};